import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const catalogEntryListCompareCollectorDescriptionSX: SxProps = {
	display: 'block',
	overflow: 'hidden',
	whiteSpace: 'normal',
	lineHeight: 1.25,
	maxHeight: '2.5em',
	wordBreak: 'break-word',
	fontWeight: OpenSansFontWeights.regular,
	color: 'grey.300',
	margin: 0,
};
